import { Balance } from "Components/Shared/Balance";
import { BankImage } from "Components/Shared/BankImage";
import { StyledFlex } from "Components/Shared/StyledComponents";
import type { Bank } from "Infrastructure/Api/Api";
import type { CurrencyCode } from "Models/CurrencyCodes";

type Props = {
  balance: number;
  // Any ISO 4217 code — API-enum and plain-string callers pass through uncast.
  currency?: CurrencyCode | string;
  isLoading?: boolean;
  bank?: Bank;
  prefix?: string;
};

export const AccountBalance = ({
  balance,
  currency,
  isLoading,
  bank,
  prefix,
}: Props) => (
  <StyledFlex justifyContent="space-between" alignItems="flex-end">
    <Balance
      balance={balance}
      currency={currency}
      isLoading={isLoading}
      prefix={prefix}
    />
    <BankImage bank={bank} isLoading={isLoading} />
  </StyledFlex>
);
